import { useEffect, useState } from "react";
import { supabase } from "../../../api";
import VisuallyHidden from "@reach/visually-hidden";
import { Avatar } from "@mui/material";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

export default function Avatarr({ url, size, onUpload }) {
  const [avatarUrl, setAvatarUrl] = useState(null);
  const [uploading, setUploading] = useState(false);
  const CustomWidthTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))({
    [`& .${tooltipClasses.tooltip}`]: {
      maxWidth: 200,
    },
  });

  useEffect(() => {
    if (url) downloadImage(url);
  }, [url]);

  const downloadImage = async (path) => {
    try {
      const { data, error } = await supabase.storage
        .from("avatars")
        .download(path);
      if (error) {
        throw error;
      }
      const url = URL.createObjectURL(data);
      setAvatarUrl(url);
    } catch (error) {
      console.log("Error downloading image: ", error.message);
    }
  };

  const uploadAvatar = async (event) => {
    try {
      setUploading(true);

      if (!event.target.files || event.target.files.length === 0) {
        throw new Error("You must select an image to upload.");
      }

      const file = event.target.files[0];
      const fileExt = file.name.split(".").pop();
      const fileName = `${Math.random()}.${fileExt}`;
      const filePath = `${fileName}`;

      let { error: uploadError } = await supabase.storage
        .from("avatars")
        .upload(filePath, file);

      if (uploadError) {
        throw uploadError;
      }

      onUpload(filePath);
    } catch (error) {
      alert(error.message);
    } finally {
      setUploading(false);
    }
  };

  return (
    <Box style={{ width: 400}} 
    aria-live="polite" 
    display="flex" 
    sx={{ flexDirection: 'column' }} 
    justifyContent="center" 
    alignItems="center">
      <Avatar
        src={avatarUrl ? avatarUrl : `https://place-hold.it/${size}x${size}`}
        alt={avatarUrl ? "Avatar" : "No image"}
        className="avatar image"
        style={{ height: size, width: size, border: "4px solid #F6F6F6" }}
      />
      {uploading ? (
        "Uploading..."
      ) : (
        <Box sx={{ mt: "10px" }}>
          <CustomWidthTooltip title="Image must be .jpg or .png with minimum size of 160x160 pixels." placement="right" arrow>
            <Button variant="outlined" component="label" color="success">
              Upload an avatar
              <EditIcon />
              <VisuallyHidden>
                <input
                type="file"
                id="single"
                accept="image/*"
                onChange={uploadAvatar}
                disabled={uploading}
                />
              </VisuallyHidden>
            </Button>
          </CustomWidthTooltip>  
        </Box>
      )}
    </Box>
  );
}
